import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsTableComponent } from './details-table.component';
import { IonicModule } from '@ionic/angular';
import {
  FaIconLibrary,
  FontAwesomeModule
} from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faXmarkCircle, faPenToSquare } from '@fortawesome/pro-light-svg-icons';
import { RouterModule } from '@angular/router';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';

const icons: IconDefinition[] = [faCheckCircle, faXmarkCircle, faPenToSquare];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule,
    TranslocoLocaleModule
  ],
  declarations: [DetailsTableComponent],
  exports: [DetailsTableComponent]
})
export class DetailsTableModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
